import { useStorage } from '@vueuse/core'

/**
 * UI preferences persisted to localStorage (shared singleton refs).
 *
 * showAdvancedModules: progressive disclosure for the consignment/logistics
 * surface. When off (default for new users), the dock + command palette hide
 * Arrivals, Settlements, Shippers and Shipments so the core workflow
 * (Orders, Products, Deliveries, Customers, Payments) isn't overwhelming.
 * Routes stay directly reachable; this only gates discovery.
 */
const showAdvancedModules = useStorage('hudstore_show_advanced_modules', false)

export function usePreferences() {
  return { showAdvancedModules }
}
